import React from "react";
import { useParams } from "react-router-dom";
import { ArrowRight, MessageCircle, Leaf } from "lucide-react";
import { BACKEND_URL } from "../lib/api";
import {
  RENA, useRenalifePage, useRenalifeCta, Eyebrow, PageShell, LoadingScreen, NotFoundScreen, VideoBlock, Footer,
} from "./RenalifeLanding";

export default function RenalifeTema() {
  const { slug, tid } = useParams();
  const { data, notFound } = useRenalifePage(slug);
  const { go, sending } = useRenalifeCta(slug, tid);

  if (notFound) return <NotFoundScreen />;
  if (!data) return <LoadingScreen />;

  const tema = (data.temas || []).find((t) => t.material_id === tid);
  if (!tema) return <NotFoundScreen />;
  const asset = data.assets?.[tid] || {};

  return (
    <PageShell testid={`renalife-tema-${tid}`}>
      <section className="min-h-screen flex items-center px-6 sm:px-12" style={{ background: `linear-gradient(160deg, ${RENA.deep} 0%, ${RENA.forest} 120%)` }}>
        <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-10 items-center py-16 w-full">
          <div>
            <Eyebrow>RENALIFE MÉXICO</Eyebrow>
            <h1 className="font-renalife font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.08] mt-5">{tema.title}</h1>
            <p className="text-base sm:text-lg mt-6 max-w-xl" style={{ color: "#cbd5d1" }}>{tema.message}</p>
            <button
              data-testid="cta-tema"
              onClick={go}
              disabled={sending}
              className="inline-flex items-center gap-2 rounded-full px-8 py-4 font-bold text-base mt-9 transition-transform hover:-translate-y-0.5"
              style={{ background: RENA.gold, color: RENA.deep }}
            >
              <MessageCircle size={17} /> {sending ? "Abriendo WhatsApp…" : "Quiero saber más por WhatsApp"}
            </button>
          </div>
          {asset.image_url ? (
            <img data-testid="tema-hero-image" src={`${BACKEND_URL}${asset.image_url}`} alt={tema.title} className="rounded-3xl border shadow-2xl w-full object-cover" style={{ borderColor: `${RENA.gold}30` }} />
          ) : (
            <div className="rounded-3xl border flex items-center justify-center aspect-[3/2]" style={{ borderColor: `${RENA.gold}25`, background: "#03251c" }}>
              <Leaf size={48} style={{ color: `${RENA.gold}60` }} />
            </div>
          )}
        </div>
      </section>

      <VideoBlock videoUrl={asset.video_url} title={tema.title} />

      <button
        data-testid="cta-tema-final"
        onClick={go}
        disabled={sending}
        className="w-full py-8 font-renalife font-bold text-xl sm:text-3xl transition-opacity hover:opacity-90 flex items-center justify-center gap-3"
        style={{ background: RENA.gold, color: RENA.deep }}
      >
        Quiero saber más — escríbeme por WhatsApp <ArrowRight size={26} />
      </button>
      <Footer name={data.distributor_name} />
    </PageShell>
  );
}
